import React from 'react';
import PropTypes from 'prop-types';

const BreadcrumbView = ({ breadcrumbs, onSelect }) => {
  const handleSelect = (breadcrumb, index) => {
    if (onSelect) {
      onSelect(breadcrumb, index);
    }
  };

  return (
    <nav aria-label="breadcrumb-custom" className="breadcrumb-custom">
      <ol className="breadcrumb">
        {breadcrumbs.map((breadcrumb, index) => (
          <li
            key={breadcrumb.label}
            className={`breadcrumb-item ${index === breadcrumbs.length - 1 ? 'active' : ''}`}
            aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
          >
            {index !== breadcrumbs.length - 1 ? (
              <a href={breadcrumb.path || '#'} className="menuitem-link"
                onClick={(e) => {  e.preventDefault(); handleSelect(breadcrumb, index); }}
                style={{ cursor: 'pointer', color: '#007bff', textDecoration: 'none' }}
              >
                {breadcrumb.label}
              </a>
            ) : (
                 <a href={breadcrumb.path || '#'} className="menuitem-link">
                    <span>{breadcrumb.label}</span>
                 </a>
            )}
            {index !== breadcrumbs.length - 1 && (
              <span className="breadcrumb-separator">
                <i className="pi pi-angle-right" />
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

BreadcrumbView.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string, // Optional path for navigation
    })
  ).isRequired,
  onSelect: PropTypes.func, // Callback for breadcrumb selection
};

export default BreadcrumbView;
